import { Component, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, EditableConfigGridData, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LenderService } from '../../service/lender.service';
import { GlobalConfigurationState } from '../../state/global-configuration.state';
import { BranchModel, DefaultSettingsModel } from '../model/valuetrust.model';
import { ValuTrustService } from '../service/valutrust.service';

@Component({
	selector: 'cv-invision-valutrust-default-setting',
	templateUrl: './valutrust-default-setting.component.html',
	styleUrls: ['./valutrust-default-setting.component.scss']
})
export class ValutrustDefaultSettingComponent implements OnInit, OnDestroy {
	public acuityBranchSelected: Array<any>;
	public cmpAcuityBranchSelected: Array<any>;
	public branchList: Array<BranchModel>;
	public clientList: Array<BranchModel>;
	public cmpAcuityLenderBranchesList: Array<BranchModel>;
	public clientBranchSelected: Array<any>;
	public defaultConfigModel: DefaultSettingsModel;
	public optionsReady: boolean;
	saving: boolean;
	isDirtyForm: boolean;

	private atComponentDestroy = new Subject();

	constructor(
		private store: Store,
		private broadcastService: BroadcastService,
		private valueTrustPropertyTypesService: ValuTrustService,
		public lenderService: LenderService
	) {
		this.defaultConfigModel = new DefaultSettingsModel();
		this.branchList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityLenderBranches);
		this.clientList = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeLenders);
		this.cmpAcuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityLenderBranches);
		this.acuityBranchSelected = [];
		this.clientBranchSelected = [];
		this.cmpAcuityBranchSelected = [];
	}

	async ngOnInit(): Promise<void> {
		this.valueTrustPropertyTypesService.setFormData({isDirty: true});
		await this.valueTrustPropertyTypesService
			.getValuTrustDefaultSettings()
			.toPromise()
			.then(result => {
				this.defaultConfigModel = result;
				if (result.defaultBranchId) {
					this.acuityBranchSelected = this.branchList.filter(
						b => b.id === this.defaultConfigModel.defaultBranchId
					);
				}
				if (result.defaultCMPBranchId) {
					this.lenderService.getCmpAcuityLenderBranches(result.defaultCMPBranchName)
						.pipe(takeUntil(this.atComponentDestroy))
						.subscribe((response : any) => {
							this.cmpAcuityLenderBranchesList = response;

							this.cmpAcuityBranchSelected = this.cmpAcuityLenderBranchesList.filter(
								b => b.id === this.defaultConfigModel.defaultCMPBranchId
							);
						})
				}
				if (this.defaultConfigModel.defaultClientId) {
					this.clientBranchSelected = this.clientList.filter(
						b => b.id === this.defaultConfigModel.defaultClientId
					);
					if (!this.clientBranchSelected.length) {
						this.onSearchAppScopeLender(this.defaultConfigModel);
					}
				}
				this.optionsReady = true;
			});

		// listen to valutrust property types config editor
		this.valueTrustPropertyTypesService
			.getFormDataListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result: EditableConfigGridData) => {
				if (result.doSave !== undefined && result.doSave) {
					this.onSave();
				}
				if (result.isDirty !== undefined) {
					this.isDirtyForm = result.isDirty;
				}
				if (result.saving !== undefined) {
					this.saving = result.saving;
				}
			});
	}

	/**
	 * On save search client appscope.
	 */
	onSearchAppScopeLender(configInf: any): void {
		this.lenderService
			.getLenders(configInf.defaultClientName)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(r => {
				this.clientBranchSelected = r.filter((b: any) => b.id === configInf.defaultClientId);
				this.optionsReady = true;
			});
	}

	/**
	 * On save grid config.
	 */
	onSave(): void {
		this.valueTrustPropertyTypesService
			.saveValuTrustDefaultSettings(this.defaultConfigModel)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result && result.succeeded) {
						this.broadcastService.broadcast({
							name: ToasterType.SUCCESS,
							event: {message: 'Default Settings saved successfully'}
						});
					}
					this.valueTrustPropertyTypesService.setFormData({saving: false, doSave: false});
				},
				error => {
					console.error(error);
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: {error: 'Error occurred ' + error}
					});
					this.valueTrustPropertyTypesService.setFormData({saving: false, doSave: false});
				}
			);
	}

	/**
	 * on branch selected
	 * @param $event
	 */
	onBranchSelected($event: any, type: string): void {
		switch (type) {
			case 'acuity':
				this.defaultConfigModel.defaultBranchId = $event?.id || '';
				this.defaultConfigModel.defaultBranchName = $event?.title || '';
				break;
			case 'cmpacuity':
				this.defaultConfigModel.defaultCMPBranchId = $event?.id || '';
				this.defaultConfigModel.defaultCMPBranchName = $event?.title || '';
				break;
			case 'appscope':
				this.defaultConfigModel.defaultClientId = $event?.id || '';
				this.defaultConfigModel.defaultClientName = $event?.title || '';
				break;
		}
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
